// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".v-dialog {\n  -webkit-transition: 0.3s cubic-bezier(0.25, 0.8, 0.25, 1) !important;\n  transition: 0.3s cubic-bezier(0.25, 0.8, 0.25, 1) !important;\n  width: 100%;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
